import { ServiceGroup, Services } from 'APP/Store/Content/types'

export function getAnalyticsScreenName(serviceGroup: ServiceGroup): string {
  return `serviceGroupScreen : ${serviceGroup.id} : ${serviceGroup.name}`
}

const SERVICE_NAMES = {
  NUTRITION: 'Nutrition Support',
}

export function determineServiceDetail(services: Services): boolean {
  return services.some((service) => service?.name === SERVICE_NAMES.NUTRITION)
}
